/**
 * CompactionSeparator — full-width rendering of the `context_compaction`
 * backend event (memory optimisation of the conversation history).
 *
 * Kept separate from the tool rendering on purpose : compaction is not a tool
 * call the lawyer triggered, it structures the conversation — so it must never
 * be absorbed into a tool group (see groupTimelineItems.ts).
 */

import React from 'react';
import { Loader2, Zap } from 'lucide-react';
import type { BackendTool } from '../../types/websocket.types';

export const CompactionSeparator: React.FC<{ status: BackendTool['payload']['status'] }> = ({ status }) => {
  if (status === 'started' || status === 'in_progress') {
    return (
      <div className="flex items-center justify-center gap-2 py-2 text-xs text-grey-400">
        <Loader2 className="w-3 h-3 animate-spin" />
        <span>Optimisation de la mémoire...</span>
      </div>
    );
  }
  if (status === 'completed') {
    return (
      <div className="flex items-center gap-3 py-3">
        <div className="flex-1 h-px bg-grey-200" />
        <div className="flex items-center gap-1.5 text-xs text-grey-400 font-medium uppercase tracking-wide">
          <Zap className="w-3 h-3" />
          <span>Historique de la conversation compressé</span>
        </div>
        <div className="flex-1 h-px bg-grey-200" />
      </div>
    );
  }
  if (status === 'error') {
    // Le backend émet désormais réellement `error` pour une compaction automatique
    // ou d'urgence (avant : jamais). Rien n'a été persisté ; sans cette ligne,
    // le « Optimisation de la mémoire... » disparaissait sans explication.
    return (
      <p className="py-2 text-center text-xs text-grey-400">
        La compaction de la mémoire a échoué. L&apos;historique est conservé intact.
      </p>
    );
  }
  return null;
};
